import type { LabelFormatterTypes } from '@apps/main/new-desktop/core/components/formatters';

import type { AppSliderProps } from '@libs/ui';
import type { IngredientId } from '@libs/trip-planner-interfaces';

import type {
  Filter,
  FilterType,
  FilterUpdateEventType,
} from '../../Filters.model';

export interface AvailableSliderFilterData extends Filter<FilterType> {
  filterType: FilterType.Slider;
  state: SliderFilterState.Default;
  options: SliderFilterProps;
  title: string;
  labelFormatter: LabelFormatterTypes;
}

export interface LoadingSliderFilterData extends Filter<FilterType> {
  filterType: FilterType.Slider;
  state: SliderFilterState.Loading;
  title: string;
}

export interface SliderFilterProps extends AppSliderProps {
  initialValue: number;
}

export interface SliderUpdateFilterEvent {
  eventType: FilterUpdateEventType.UpdateFilter;
  filterType: FilterType.Slider;
  value: number;
  ingredientId: IngredientId;
}

export type SliderFilterData =
  | AvailableSliderFilterData
  | LoadingSliderFilterData;

export const enum SliderFilterState {
  Default = 'Default',
  Loading = 'Loading',
}
